module.exports = __webpack_public_path__ + "waveform-bottom-warm.f4d7f53.png";